export const environment = {
    production: false,
    serviceUrl: '/api',
    backendUrl: 'http://localhost:8080',
    paymentProvider: 'FAKE',
    google: {
        clientId: '202473567396-q6uktkf2tk03o49u4ctd2iupjk17rsjo.apps.googleusercontent.com',
        redirectUrl: 'http://localhost:4201/auth/google',
    },
    recaptchaSiteKey: '6LevMAQqAAAAAJIm3isrYKWQ_Hut95L6jQzvRRnj',
    siteTitle: 'Quizzaro',
    siteUrl: 'http://localhost:4201',
    domain: 'localhost',
    heapAppId: 1437839945,
    imaAdTagUrl: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_preroll_skippable&sz=640x480&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator='
}
